import { isDate, isValid, parse } from 'date-fns';

import { DATE_FORMATS } from '../../../../../../constants';

export const parseDate = (
  dateString: string,
  source: 'user-input' | 'value',
): Date | undefined => {
  if (source === 'value' || /^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
    const parsedDate = parse(
      dateString,
      source === 'user-input' ? DATE_FORMATS.standard : DATE_FORMATS.keys,
      new Date(),
    );

    if (isDate(parsedDate) && isValid(parsedDate)) {
      return parsedDate;
    }
  }

  return undefined;
};
